import { cond, constant, stubTrue } from 'lodash-es';
import { formatPriceStringV2 } from 'site-modules/shared/utils/price-utils';

const DOTS = {
  A: { id: 'A', position: 6.25 },
  B: { id: 'B', position: 18.75 },
  C: { id: 'C', position: 37.5 },
  D: { id: 'D', position: 50 },
  E: { id: 'E', position: 62.5 },
  F: { id: 'F', position: 87.5 },
};

const makeMedianDot = ({ id, position, median }) => ({
  id,
  position,
  theme: 'gray',
  label: { normal: `typical: ${formatPriceStringV2(median)}/mo` },
});

const makePaymentDot = ({ id, position, payment, theme, hasGem = false }) => ({
  id,
  position,
  theme,
  hasShadow: true,
  hasGem,
  label: { bold: `${formatPriceStringV2(payment)}/mo` },
});

const makeMergedDot = ({ id, position, payment }) => ({
  id,
  position,
  theme: 'blue',
  hasShadow: true,
  label: { bold: `${formatPriceStringV2(payment)}/mo`, suffix: ' is typical' },
});

export const getDotsConfig = (payment, median, rating) => {
  const hasMedian = !!median;
  const diff = hasMedian ? median - payment : null;
  const isMid = rating === 2 || rating === 3;

  const medianDot = baseDot => (hasMedian ? makeMedianDot({ ...baseDot, median }) : null);

  const getDots = cond([
    [
      () => rating === 5,
      constant([makePaymentDot({ ...DOTS.A, payment, theme: 'green', hasGem: true }), medianDot(DOTS.D)]),
    ],
    [
      () => rating === 4,
      constant([makePaymentDot({ ...DOTS.B, payment, theme: 'green', hasGem: true }), medianDot(DOTS.D)]),
    ],
    [() => rating === 1, constant([makePaymentDot({ ...DOTS.F, payment, theme: 'orange' }), medianDot(DOTS.D)])],
    [() => isMid && !hasMedian, constant([makePaymentDot({ ...DOTS.D, payment, theme: 'blue' })])],
    [() => isMid && Math.abs(diff) <= 50, constant([makeMergedDot({ ...DOTS.D, payment })])],
    [() => isMid && diff > 50, constant([makePaymentDot({ ...DOTS.C, payment, theme: 'blue' }), medianDot(DOTS.E)])],
    [() => isMid && diff < -50, constant([medianDot(DOTS.C), makePaymentDot({ ...DOTS.E, payment, theme: 'blue' })])],
    [stubTrue, constant([])],
  ]);

  return getDots().filter(Boolean);
};
